export default __webpack_public_path__ + "static/media/consentry-hero-img.d8538eca.svg";